<script setup>
import BaseModal from "../global/modals/BaseModal.vue";

const emit = defineEmits(['close']);
</script>

<template>
  <Teleport to="body">
    <BaseModal
      id="custom-domain-setup-modal"
      @close="emit('close')"
    >
      <template #heading>
        Setup your custom domain in 3 easy steps
      </template>
      <div>
        <div class="row mb-5 align-items-center">
          <div class="col-3">
            <svg-vue
              class="svg"
              icon="illustrations/custom-domain-img-1"
            />
          </div>
          <div class="col">
            <h3 class="font-weight-bold">
              1. Choose your custom domain
            </h3>
            <p>
              Select the custom domain you want to use for the platform, this can be any domain / subdomain that you have
              access to. e.g. <span class="font-weight-bold domain">dash.mywebsite.com</span>
            </p>
            <p class="text-danger font-weight-bold">
              Please note that some registrars restrict setting CNAME records for root domains, if you have any issues
              please contact your registrar for advice.
            </p>
          </div>
        </div>

        <div class="row mb-5 align-items-center">
          <div class="col-3">
            <svg-vue
              class="svg"
              icon="illustrations/custom-domain-img-2"
            />
          </div>
          <div class="col">
            <h3 class="font-weight-bold">
              2. Update the DNS for your custom domain
            </h3>
            <p>
              All you need to do is to add a CNAME record for the custom domain and point it to
              "<span class="font-weight-bold domain">domains.hike.marketing</span>".
              Any problems please reach out over live chat.
            </p>
          </div>
        </div>

        <div class="row mb-5 align-items-center">
          <div class="col-3">
            <svg-vue
              class="svg"
              icon="illustrations/custom-domain-img-3"
            />
          </div>
          <div class="col">
            <h3 class="font-weight-bold">
              3. Check for domain verification
            </h3>
            <p>
              We'll proceed to verify your custom domain to ensure it's configured properly. Should there be any concerns,
              they'll be displayed on this page. After making any modifications, please click the "Re-verify" button so we
              can
              reassess the domain's status.
            </p>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="w-100 d-flex justify-content-center">
          <button
            class="border-0 border-radius-6 btn-block button font-weight-bold h-100 px-5 btn-success w-auto"
            @click="emit('close')"
          >
            Continue
          </button>
        </div>
      </template>
    </BaseModal>
  </Teleport>
</template>

<style>
#custom-domain-setup-modal .svg {
  max-width: 150px;
  width: 100%;
}
#custom-domain-setup-modal .modal_window {
  padding: 3.5rem !important;
  max-width: 900px;
}
#custom-domain-setup-modal .heading {
  font-weight: 500 !important;
  font-size: 28px !important;
  margin-bottom: 2rem !important;
}
#custom-domain-setup-modal .domain {
  color: #00C6DD;
}
</style>
